export const CHUNK_RELOAD_ATTEMPTED_KEY = 'dla_chunk_reload_attempted';
export const CHUNK_RELOAD_IN_PROGRESS_KEY = 'dla_chunk_reload_in_progress';

function getErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err) {
    const message = (err as { message: unknown }).message;
    return typeof message === 'string' ? message : '';
  }
  return typeof err === 'string' ? err : '';
}

export function isChunkLoadError(err: unknown): boolean {
  const msg = getErrorMessage(err);
  return (
    /error loading dynamically imported module/i.test(msg) ||
    /loading chunk.*failed/i.test(msg) ||
    /chunkloaderror/i.test(msg) ||
    /failed to fetch dynamically imported module/i.test(msg)
  );
}

export function isCssPreloadError(err: unknown): boolean {
  const msg = getErrorMessage(err);
  return /unable to preload css/i.test(msg);
}
